// extracted by mini-css-extract-plugin
export default {"container":"QF-z","innerContainer":"RF-z","multipleLines":"SF-z","heading":"TF-z","content":"UF-z","linkColor":"VF-z"};